import React, { Fragment, useEffect } from 'react';
import Calendar from '../../../shared/components/Calendar/Preview';
import CloseIcon from '../../../shared/components/Icons/Close';
import Notifications from '../../../shared/components/Notifications';
import Popover from '../../../announcements/components/Popover';
// import Scheme from '../Scheme';
import Scheme from '../../../common/components/Scheme';
import TicketsModal from '../../../shared/components/TicketsModal';
import Styled from './styles';
import { AnnouncementsGlobalStyles } from '../../../styles/global';
import Alerts from '../../../shared/components/Alerts';
import useLayout from '../../../hooks/useLayout';
// import Filters from '../Filters';
import { Settings } from '../../../types/settings';
import { SIDE_BAR_POSITION } from '../../../types/sideBar';
import CategoryModal from '../../../marketplace/components/CategoryModal';
import MobileOverlay from '../../../common/components/MobileOverlay';

import ErrorMessage from '../ErrorMessage';
import Help from '../Help';
import HelpButton from '../HelpButton';
import OrderForm from '../OrderForm';
import ReloadOverlay from '../ReloadOverlay';
import Zoom from '../Zoom';
import Prices from '../Prices';
import Nav from '../Nav';
// TODO: dynamic import
import SidebarLanding from '../SideBar/SideBar.landing';
import Sidebar from '../SideBar/SideBar.marketplace';
import TicketsCountModal from '../TicketsCountModal';
import LandingTicketsCountModal from '../../../common/components/TicketsCountModal';
import IDS from '../../../constants/IDS';

interface Props {
  loadSeats?: (uuid: string) => void;
  uuid: string;
  previewMode: boolean;
  event: number;
  settings?: Settings;
}

// const SidebarLanding = lazy(() => import('../SideBar/SideBar.landing'));
// const Sidebar = lazy(() => import('../SideBar/SideBar.marketplace'));

const Layout = (props: Props) => {
  const { Widget } = window;
  const { settings } = props;
  const {
    state,
    showMobileOverlayFC,
    toggleReloadOverlay,
    setSideBarPosition,
    hideMobileOverlayFC,
  } = useLayout();
  const {
    previewMode,
    withoutFullscreen,
    termsUrl,
    personalDataTermsUrl,
    reloadMinutes,
    hideMobileOverlay,
  } = settings;
  const {
    isFullscreen,
    orderFormIsHidden,
    isFailure,
    reloadOverlayVisible,
    schemeMode,
    isGripperDisabled,
    sideBarPosition,
    showMobileOverlay,
  } = state;
  const { isPeriodical } = Widget.metaController.meta;
  const { isLanding } = Widget.settings;
  const mobileOverlayIsVisible =
    !isFailure &&
    orderFormIsHidden &&
    showMobileOverlay &&
    !reloadOverlayVisible &&
    !hideMobileOverlay;
  const withSidebar = window.Widget.announcementsController.count !== 0;
  useEffect(() => {
    if (isLanding && mobileOverlayIsVisible) {
      // window.Widget.stateController.lock();
    }
  }, []);

  // const openFilters = () => toggleFilters(true);
  // const closeFilters = () => toggleFilters(false);

  return (
    <Styled.Wrapper id={IDS.rootLayout}>
      <AnnouncementsGlobalStyles.Global />

      {/* <Suspense fallback={"loading..."}> */}
      {isLanding ? (
        <SidebarLanding
          position={sideBarPosition}
          setPosition={setSideBarPosition}
          isGripperDisabled={isGripperDisabled}
          // openFilters={openFilters}
        />
      ) : (
        <Sidebar
          position={sideBarPosition}
          setPosition={setSideBarPosition}
          isGripperDisabled={isGripperDisabled}
          // openFilters={openFilters}
        />
      )}
      {/* </Suspense> */}

      {/* <Filters isOpen={state.isFiltersOpen} closeFilters={closeFilters} /> */}
      {isLanding && mobileOverlayIsVisible && <MobileOverlay onClick={hideMobileOverlayFC} />}

      <Styled.Layout isFullscreen={isFullscreen} withSidebar={withSidebar}>
        {isFailure && <ErrorMessage />}
        {isFullscreen && (
          <Styled.CloseButton onClick={showMobileOverlayFC} isPeriodical={isPeriodical}>
            <CloseIcon />
          </Styled.CloseButton>
        )}

        {!previewMode && isLanding && <Nav layoutState={{ ...state, previewMode }} />}
        {!previewMode && !isFailure && !isLanding && schemeMode && (
          <Fragment>
            <Prices />
          </Fragment>
        )}

        <Scheme
          previewMode={previewMode}
          isFullscreen={isFullscreen}
          isFailure={isFailure}
          hidden={!schemeMode}
          widget={Widget}
        />
        {!isFailure && orderFormIsHidden && (
          <Zoom
            sideBarPosition={sideBarPosition}
            hideZoom={!schemeMode}
            toggleFullscreen={Widget.toggleFullscreen}
            isFullscreen={isFullscreen}
            withoutFullscreen={withoutFullscreen}
          />
        )}

        <Alerts sideBarPosition={sideBarPosition} />

        <HelpButton isTopPosition={sideBarPosition === SIDE_BAR_POSITION.MIDDLE} />

        {orderFormIsHidden && schemeMode && <Popover />}
        {orderFormIsHidden && <TicketsModal />}
        {!orderFormIsHidden && (
          <OrderForm
            termsUrl={termsUrl}
            personalDataTermsUrl={personalDataTermsUrl}
            isFullscreen={isFullscreen}
          />
        )}

        <Notifications />
      </Styled.Layout>
      <Calendar />
      {isLanding ? <LandingTicketsCountModal /> : <TicketsCountModal />}
      <CategoryModal />
      <Help />

      {!isFailure && (
        <ReloadOverlay
          reloadMinutes={reloadMinutes}
          toggle={toggleReloadOverlay}
          isVisible={reloadOverlayVisible}
        />
      )}
    </Styled.Wrapper>
  );
};

export default Layout;
